import { useEffect } from "react";

// Toggles a plain class + CSS var on the row; OutlineTable.module.scss's global rule (with
// !important, beating GenericTable's own) applies it to the row and cascades to every cell.
export const THEMED_ROW_CLASS = "outline-row-themed";

export const useRowThemeBackground = (
  rowRef,
  isGroupHovered,
  theme,
  hoverChangeKey
) => {
  useEffect(() => {
    const rowElement = rowRef.current?.closest(".body-row");

    if (!rowElement) {
      return undefined;
    }

    const isThisRowHovered = rowElement.classList.contains("hovered");

    const backgroundColor = isThisRowHovered
      ? theme.itemHover
      : isGroupHovered
        ? theme.group
        : null;

    if (!backgroundColor && !rowElement.classList.contains(THEMED_ROW_CLASS)) {
      return undefined;
    }

    if (backgroundColor) {
      rowElement.style.setProperty(
        "--outline-row-theme-color",
        backgroundColor
      );
      rowElement.classList.add(THEMED_ROW_CLASS);
    } else {
      rowElement.style.removeProperty("--outline-row-theme-color");
      rowElement.classList.remove(THEMED_ROW_CLASS);
    }

    return () => {
      rowElement.style.removeProperty("--outline-row-theme-color");
      rowElement.classList.remove(THEMED_ROW_CLASS);
    };
  }, [rowRef, isGroupHovered, theme, hoverChangeKey]);
};

export default useRowThemeBackground;
